import { render, staticRenderFns } from "./ActiveContractCard.vue?vue&type=template&id=71a97942&scoped=true"
import script from "./ActiveContractCard.vue?vue&type=script&lang=js"
export * from "./ActiveContractCard.vue?vue&type=script&lang=js"
import style0 from "./ActiveContractCard.vue?vue&type=style&index=0&id=71a97942&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a97942",
  null
  
)

export default component.exports